<script setup>
import { useHead } from '@unhead/vue';
import BrandForm from '../../scripts/components/contactForm/BrandForm.vue';
import CarouselGeneric from '../../scripts/components/CarouselGeneric.vue';

const imagesGlob = import.meta.glob('../../images/brands/moleskine/products/*', { eager: true });

useHead({});

const products = [
	{
		title: "Metro Rolltop Backpack",
		src: imagesGlob["../../images/brands/moleskine/products/swaggerproductpagewebsiteproductsmoleskin4metro-rolltop-backpack.png"].default
	},
	{
		title: "Notebook Backpack",
		src: imagesGlob["../../images/brands/moleskine/products/swaggerproductpagewebsiteproductsmoleskin7notebook-backpack.png"].default
	},
	{
		title: "Metro Backpack",
		src: imagesGlob["../../images/brands/moleskine/products/swaggerproductpagewebsiteproductsmoleskin5metro-backpack.png"].default
	},
	{
		title: "Hard Cover Ruled Notebook",
		src: imagesGlob["../../images/brands/moleskine/products/swaggerproductpagewebsiteproductsmoleskin8hard-cover-ruled-notebook.png"].default
	},
	{
		title: "Coloring Kit",
		src: imagesGlob["../../images/brands/moleskine/products/swaggerproductpagewebsiteproductsmoleskin6coloring-kit.png"].default
	},
	{
		title: "Smart Writing Set",
		src: imagesGlob["../../images/brands/moleskine/products/swaggerproductpagewebsiteproductsmoleskin2smart-writing-set.png"].default
	},
	{
		title: "Pocket Notebook and GO Pen Gift Set",
		src: imagesGlob["../../images/brands/moleskine/products/swaggerproductpagewebsiteproductsmoleskin3pocket-notebook-and-go-pen-gift-set.png"].default
	},
	{
		title: "Notebook and Kaweco Pen Gift Set",
		src: imagesGlob["../../images/brands/moleskine/products/swaggerproductpagewebsiteproductsmoleskin9notebook-and-kaweco-pen-gift-set.png"].default
	},
	{
		title: "Classic Vertical Device Bag",
		src: imagesGlob["../../images/brands/moleskine/products/swaggerproductpagewebsiteproductsmoleskin1classic-vertical-device-bag.png"].default
	}, 
]
</script>

<template lang="pug">
.page.page--brand.carhartt
	section.hero
		.hero__bg
		.hero__content
			.copy
				img(src='@static/images/brands/moleskine/logo.png')
				h1 Custom Moleskine
			.image
				img(src='@static/images/brands/moleskine/hero.png' alt="Close up of black and blue Moleskine notebooks, with the blue one slightly open to reveal the Moleskine logo.")
	section.section.section--subhero
		.section__content
			.copy
				h3 Unleash Your Genius
				p Minimalist in design but rich in meaning, Moleskine’s iconic notebooks, bags, and accessories have earned a place on the desks and in the hands of creatives, strategists, and forward-thinkers alike. Today, they’re a staple for modern professionals and brands who value thoughtfulness, quality, and intentionality. Whether it’s capturing ideas, planning ahead, or making a lasting impression, custom Moleskine by Swagger transforms everyday essentials into meaningful expressions.

	.page__content
		section.section.section--products
			.section__content
				CarouselGeneric(name="productCarousel" :innerNav="false" :perPage="{ 0: 1, 751: 3 }")
					.product-card(v-for="product in products")
						.product-card__image
							img(:src="product.src" :alt="`Custom Moleskine ${product.title}`")
						.product-card__text
							p {{product.title}}
							

		
		section.section.section--form
			.section__content
				h2 Love this brand?<br/>Let's make something cool together
				p Please fill out this form so we can help you with your upcoming project.
				.form-wrap
					BrandForm(formName="moleskine")
		
		section.section.section--detail
			.stripe
				img(src='@static/images/brands/moleskine/banner.png' alt="Smiling students in a classroom proudly holding up books, capturing a joyful moment of shared learning and inspiration.")
			.section__content
				.copy
					h2 IMPACT, IN EVERY PAGE
					p A Moleskine gift goes beyond great design. Through partnerships like Room to Read, each notebook helps fund libraries and schools across Asia and Africa, supporting literacy, creativity, and opportunity where it’s needed most.
					p Choose Moleskine, and you’re not just elevating your brand, you’re joining a movement that’s writing a better future.
		
		section.section.section--foot
			.bg
			.section__content

</template>

<style></style>